<template>
  <div class="chat-content">
    <button type="button" class="chat-content__close" @click="closeChat">
      <RemixIconComponent category="System" name="close-line" />
    </button>
    <ChatMessages v-if="chat" :chat="chat" :shop="shop" @remove-chat="removeChat" />
    <ChatList v-else @set-chat="setChat" @set-chat-admin="setChatAdmin" />
  </div>
</template>

<script>
import ChatList from "./ChatContent/ChatList.vue";
import ChatMessages from "./ChatContent/ChatMessages.vue";
import RemixIconComponent from "components/RemixIconComponent.vue";
import { eventBus } from "../../../utils";

export default {
  components: { ChatList, ChatMessages, RemixIconComponent },
  data() {
    return {
      shop: null,
      chat: null,
    };
  },
  mounted() {
    eventBus.$on("set-chat", (shop, chat) => {
      this.setChat(shop, chat);
    });
  },
  methods: {
    setChat(shop, chat) {
      this.shop = shop;
      this.chat = chat;
    },
    setChatAdmin(chat) {
      this.chat = chat;
    },
    removeChat() {
      this.chat = null;
    },
    closeChat() {
      eventBus.$emit("chatOpen", false);
    },
  },
};
</script>

<style lang="stylus" scoped>
.chat-content{
  background-color #fff
  border-radius 10px
  box-shadow: 4px 0 24px rgba(0, 0, 0, .12);
  overflow hidden
  height: 600px;
  max-height: calc(100vh - 212px);
  min-height: 360px;
  position: relative
  
  @media (max-width: 480px) {
    height: auto;
    max-height: 80vh;
    min-height: 300px;
    width: 100%;
  }
  
  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    
    .icon {
      width: 20px;
      height: 20px;
    }
    
    svg {
      fill: var(--accent);
    }
    
    &:hover svg {
      fill: var(--accent-hover);
    }
  }
}
</style>
